// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1MmJP","boxTitle":"Qualiphy_boxTitle__1BZuU","box":"Qualiphy_box__1ok4V","toggleWrap":"Qualiphy_toggleWrap__3wRBL"};